/* global Sys, Core */
Sys.ns("Core");

/**
 * Module for handling bonus messages.
 *
 * @class Core.BonusMessage
 * @extends Core.Module
 */
Core.BonusMessage = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.BonusMessage.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    getDefaultMVCClasses: function() {
        return {
            model: Core.Model,
            controller: Core.BonusMessageController
        };
    }
};

Core.BonusMessage = Sys.extend(Core.Module, Core.BonusMessage, "Core.BonusMessage");
